import { createTheme, responsiveFontSizes } from "@mui/material/styles";

// アプリ全体で唯一のテーマ。ページ側で createTheme() を作らないこと。
// responsiveFontSizes によって h1〜h6 は画面幅が狭いほど自動的に小さくなるので、
// モバイル用のフォントサイズを各ページで個別に指定する必要はない。
const theme = responsiveFontSizes(
  createTheme({
    typography: {
      fontFamily: "Noto Sans SC",
      // トップページのキャッチコピー用。lg 以上でこの大きさになる。
      h3: {
        fontSize: "3.6rem",
      },
    },
  }),
);

export default theme;
